/**
 * TravelTainmentRatings component.
 */
define(['jQuery',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin',
        'clientComponents/traveltainmentratings/travelTainmentRatingsReviews'
    ],
    function ($, Object, OptionsMixin, TravelTainmentRatingsReviews) {
        const TravelTainmentRatings = function (element, requestHandler) {
            // Set default options
            let defaultOptions = {
                loadingClass: 'is-loading',
                ratingsContainerSelector: '[data-fcse-role="customer-reviews-container"]',
                ratingsSelector: '[data-fcse-role="customer-ratings"]',
                ratingPaginationSelector: '[data-fcse-role="pagination"] [data-page]',
                getHotelRatingsRoute: 'allt_frontend.get_hotel_ratings'
            };

            // Store element
            this.element = $(element);

            // Save local variables
            this.requestHandler = requestHandler;
            this.routeOptions = {
                page: 1
            };

            this.addOptions(defaultOptions);
            this.init();
        };

        TravelTainmentRatings.prototype = $.extend(Object.create(OptionsMixin), {
            /**
             * Initialize TravelTainmentRatings
             * @private
             */
            init: function () {
                const requestHandler = this.requestHandler;

                requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                requestHandler.on('error', $.proxy(this._onLoadContentError, this));

                this.ratingsContainer = this.element.find(this.option('ratingsContainerSelector'));
                new TravelTainmentRatingsReviews(this.ratingsContainer, requestHandler);

                // Initialize paging
                this.element.on('click', this.option('ratingPaginationSelector'),
                    $.proxy(this._onPaginationClick, this));

                this.element.on('mouseover', '[data-fcse-role="group-rating-container"]', function (e) {
                    $('[data-fcse-role="group-rating-details"]').hide();
                    $(this).find('[data-fcse-role="group-rating-details"]').show();
                });

                this.element.on('mouseout', '[data-fcse-role="group-rating-container"]', function (e) {
                    $('[data-fcse-role="group-rating-details"]').hide();
                });
            },

            _onPaginationClick: function (event) {
                const page = parseInt($(event.currentTarget).attr('data-page'));
                if (this.routeOptions.page !== page) {
                    this.routeOptions.page = page;

                    this.ratingsContainer.addClass(this.option('isLoadingClass'));

                    this._loadContent({}, {
                        iffCode: this.element.data('iffcode'),
                        page: page,
                        travelledAs: this.element.data('travelled-as')
                    });
                }
            },

            /**
             * Handler for content loading success
             *
             * @param event
             * @param data
             * @protected
             */
            _onLoadContentSuccess: function (event, data) {
                // Check if ajax response is from getHotelRatingsRoute
                if (data.route !== this.option('getHotelRatingsRoute')) {
                    return;
                }

                if (typeof data.routeParams.page === 'undefined') {
                    return;
                }

                if (data.routeParams.page !== this.routeOptions.page) {
                    return;
                }

                if (data.queryParams.tabName !== this.element.data('tab-name')) {
                    return;
                }
                $("html, body").animate({ scrollTop: this.ratingsContainer.offset().top }, 'slow');

                // Unset loading state
                this.element.removeClass(this.option('loadingClass'));

                // Replace HTML content
                this.ratingsContainer.html(event.html);
            },

            /**
             * Handler for content loading error
             * @param event
             * @private
             */
            _onLoadContentError: function (event) {
                if (typeof event.queryParams.tabName === "undefined" &&
                    typeof event.routeParams.ratingId === "undefined") {
                    return;
                }

                let tabName = this.element.parents('[data-fcse-role="hotel-ratings-tab"]').data('tab-name');
                if (!tabName) {
                    tabName = this.element.data('tab-name');
                }
                if (event.queryParams.tabName !== tabName && event.route !== 'allt_frontend.get_hotel_rating') {
                    return;
                }

                // Unset loading state
                $('[data-fcse-role="traveltainment-container"]')
                    .find('.' + this.option('loadingClass'))
                    .removeClass(this.option('loadingClass'));

                let msgElem = $('[data-tab-name="' + tabName + '"]').parent().find('[data-fcse-role="rating-messages"]');

                if (msgElem.length) {
                    msgElem.show('slow');
                    $('html,body').animate({scrollTop: msgElem.offset().top - ($(window).height()/2)}, 'slow');
                    window.setTimeout(function () {
                        msgElem.hide('slow');
                    }, 7000);
                }

            },

            /**
             * @private
             */
            _loadContent: function (params, routeParams) {
                params = params||{};
                routeParams = routeParams||{};
                // Set loading state
                this.element.addClass(this.option('loadingClass'));
                params.tabName = this.element.data('tab-name');

                // Send request
                this.requestHandler.cancel(this.option('getHotelRatingsRoute'));
                this.requestHandler.send(this.option('getHotelRatingsRoute'), params, routeParams);
            }
        });

        return TravelTainmentRatings;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/traveltainmentratings/travelTainmentRatings.js